import { FC } from 'react'
import { Tooltip } from 'antd'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import 'dayjs/locale/zh-cn'

dayjs.extend(relativeTime)
dayjs.locale('zh-cn')

const RELATIVE_THRESHOLD_DAYS = 7
const EMPTY = '-'

const pad = (n: number) => (n < 10 ? `0${n}` : `${n}`)

const toDayjs = (iso?: string) => {
  if (!iso) return null
  const d = dayjs(iso)
  return d.isValid() ? d : null
}

export const formatDateTime = (iso?: string): string => {
  const d = toDayjs(iso)
  if (!d) return iso ? iso.replace('T', ' ').slice(0, 19) : EMPTY
  return `${d.format('YYYY-MM-DD')} ${d.format('HH:mm:ss')}`
}

export const formatDate = (iso?: string): string => {
  const d = toDayjs(iso)
  if (!d) return EMPTY
  return d.format('YYYY-MM-DD')
}

export const formatClock = (iso?: string): string => {
  const d = toDayjs(iso)
  if (!d) return EMPTY
  return `${pad(d.hour())}:${pad(d.minute())}:${pad(d.second())}`
}

export const formatRelative = (iso?: string): string => {
  const d = toDayjs(iso)
  if (!d) return EMPTY
  const diffDays = Math.abs(d.diff(dayjs(), 'day'))
  if (diffDays >= RELATIVE_THRESHOLD_DAYS) {
    return d.year() === dayjs().year() ? d.format('MM-DD HH:mm') : d.format('YYYY-MM-DD HH:mm')
  }
  return d.fromNow()
}

export const formatDateTimeWithRelative = (iso?: string): string => {
  const exact = formatDateTime(iso)
  if (exact === EMPTY) return EMPTY
  const rel = formatRelative(iso)
  if (rel === EMPTY || rel === exact) return exact
  return `${exact}（${rel}）`
}

export const TimeAgo: FC<{ iso?: string }> = ({ iso }) => {
  const exact = formatDateTime(iso)
  if (exact === EMPTY) {
    return <span style={{ color: 'rgba(0,0,0,0.45)' }}>{EMPTY}</span>
  }
  const rel = formatRelative(iso)
  return (
    <Tooltip title={exact}>
      <span style={{ cursor: 'default' }}>{rel}</span>
    </Tooltip>
  )
}
